import { url } from '../constants/api';
import { getAuthData } from '../hooks/useAuth';
import { createDeploymentLink } from '../pages/home/websites/helpers';

//Should i open this in new tab or in the same tab? when user log in
export const createAndOpenDeploymentUrl = (
  slug,
  deploymentUrl,
  key,
  target
) => {
  const parentUrl = btoa(window.location.href);
  const saveUrl = `${url(`website-configurations/${key}/save`)}`;
  // Pass a url to save changes with access token and website Id and remove this whole dependency of message
  // In future we will issue a unique token for editing that expires after
  // a certain amount of activity

  window.open(
    `${createDeploymentLink(deploymentUrl, slug)}?_editToken=${btoa(saveUrl)}&authorization=${getAuthData()?.accessToken}&parentUrl=${parentUrl}`,
    `${target || '_blank'}`
  );
};
